import { LoginForm, LoginRequest } from "@/ServerTypes/Membership";
import { Texts } from "@/ServerTypes/Texts";
import { PropertyPanel, ErrorHandling, isEmptyOrNull, notifyError, parseQueryString, resolveUrl, serviceCall, ServiceResponse, localText, htmlEncode } from "@serenity-is/corelib";



$(function () {
    var loginPanel = new LoginPanel($('#LoginPanel')).init();
    loginPanel.element.find('.forgot-password').appendTo('.field.Password');

    if ((document.getElementById('IsPublicDemo') as HTMLInputElement)?.value) {
        loginPanel["byId"]('Username').val('admin').attr('placeholder', 'admin')
        loginPanel["byId"]('Password').val('serenity').attr('placeholder', 'serenity');
    }

    if ((document.getElementById('Activated') as HTMLInputElement)?.value) {
        loginPanel["byId"]('Username').val((document.getElementById('Activated') as HTMLInputElement)?.value);
        loginPanel["byId"]('Password').focus();
    }
});

class LoginPanel extends PropertyPanel<LoginRequest, any> {

    protected getFormKey() { return LoginForm.formKey; }

    constructor(container: JQuery) {
        super(container);
        $.fn['vegas'] && $('#LoginSliders')['vegas']({
            delay: 30000,
            cover: true,
            overlay: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACAQMAAABIeJ9nAAAAA3NCSVQICAjb4U" +
                "/gAAAABlBMVEX///8AAABVwtN+AAAAAnRSTlMA/1uRIrUAAAAJcEhZcwAAAsQAAALEAVuRnQsAAAAWdEVYdENyZWF0" +
                "aW9uIFRpbWUAMDQvMTMvMTGrW0T6AAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M1cbXjNgAAAAxJREFUCJljaGBgAAABhACBrONIPgAAAABJRU5ErkJggg==",
            slides: [
                { src: resolveUrl("~/Content/site/slides/slide3.jpg"), transition: 'fade' },
                { src: resolveUrl("~/Content/site/slides/slide2.jpg"), transition: 'zoomOut' },
                { src: resolveUrl("~/Content/site/slides/slide1.jpg"), transition: 'swirlLeft' },
                { src: resolveUrl("~/Content/site/slides/slide4.jpg"), transition: 'fade' },
            ]
        });

        this.byId('LoginButton').click(e => {
            e.preventDefault();

            if (!this.validateForm())
                return;

            var request = this.getSaveEntity();

            serviceCall({
                url: resolveUrl('~/Account/Login'),
                request: request,
                onSuccess: () => {
                    this.redirectToReturnUrl();
                },
                onError: (response: ServiceResponse) => {
                    if (response != null && response.Error != null && response.Error.Code == "RedirectUserTo") {
                        window.location.href = response.Error.Arguments;
                        return;
                    }

                    if (response != null && response.Error != null && !isEmptyOrNull(response.Error.Message)) {
                        notifyError(response.Error.Message);
                        $('#Password').focus();

                        return;
                    }

                    ErrorHandling.showServiceError(response.Error);
                }
            });
        });
    }

    protected redirectToReturnUrl() {
        var q = parseQueryString();
        var returnUrl = q['returnUrl'] || q['ReturnUrl'];
        if (returnUrl && /^\//.test(returnUrl)) {
            var hash = window.location.hash;
            if (hash != null && hash != '#')
                returnUrl += hash;
            window.location.href = returnUrl;
        }
        else {
            window.location.href = resolveUrl('~/');
        }
    }

    protected getTemplate() {
        //<h3>${ htmlEncode(Texts.Site.SiteName) } </h3>
        return `
<div class="flex-layout">
    <div class="logo"></div>
    <h3>${htmlEncode(Texts.Forms.Membership.Login.LoginToYourAccount)}</h3>
    <form id="~_Form" action="">
        <div class="s-Form">
            <div class="fieldset ui-widget ui-widget-content ui-corner-all">
                <div id="~_PropertyGrid"></div>
                <div class="clear"></div>
            </div>
            <div class="buttons">
                <button id="~_LoginButton" type="submit" class="btn btn-primary">
                    ${htmlEncode(Texts.Forms.Membership.Login.SignInButton)}
                </button>
            </div>
            <div class="actions">
                <a href="${resolveUrl('~/Account/ForgotPassword')}"><i class="fa fa-angle-right"></i>&nbsp;${htmlEncode(Texts.Forms.Membership.Login.ForgotPassword)}</a>
                <a href="${resolveUrl('~/Account/SignUp')}"><i class="fa fa-angle-right"></i>&nbsp;${htmlEncode(Texts.Forms.Membership.Login.SignUpButton)}</a>
                <div class="clear"></div>
            </div>
        </div>
    </form>
</div>

`;
    }
}